import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import numberUtils from 'app/shared/utils/numberUtils';

import {
    Anchor,
    Spacer,
    Text,
} from '@zillow/constellation';

// styles
import './style.scss';

const propTypes = {
    leadData: PropTypes.object.isRequired,
    listingData: PropTypes.object.isRequired,
};

function LeadRequest({
    isScreenMobile, leadData, listingData, children,
}) {
    const {
        name: leadName,
        timestamp,
        email,
        message,
        phone,
    } = leadData;

    const { name: listingName } = listingData;
    const isTwilioRecording = message ? message.indexOf('twilio') > -1 : false;

    // tour
    const requestHeader = 'Inquiry';
    const date = new Date(timestamp);
    const leadDateSaved = date.toLocaleString('en-US', { timeZone: 'America/New_York' });

    return (
        <div className="LeadRequest">
            <div className="LeadRequest-Header">
                <Text
                    className="LeadRequest-Title"
                    fontType="finePrint"
                >
                    {requestHeader}
                </Text>

                <Text
                    className="LeadRequest-DateSaved"
                    fontType="finePrint"
                >
                    {`${leadDateSaved} ET`}
                </Text>
            </div>

            <Spacer className="LeadRequest-HR" />

            <Text
                className="LeadRequest-ListingName"
                fontType="finePrint"
            >
                {listingName}
            </Text>

            <Spacer paddingY="xs">
                <Text
                    className="LeadRequest-LeadName"
                    fontType="h4"
                >
                    {leadName}
                </Text>
            </Spacer>

            <div className="LeadRequest-Contact">
                {isScreenMobile ? (
                    <div
                        className={cx([
                            'LeadRequest-Contact-Phone',
                            'LeadRequest-Contact-Phone--mobile',
                        ])}
                    >
                        <Anchor
                            href={`tel:${phone}`}
                            escape={true}
                        >
                            {numberUtils.formatPhoneNumber(phone)}
                        </Anchor>
                    </div>
                ) : (
                    <div
                        className={cx([
                            'LeadRequest-Contact-Phone',
                            'LeadRequest-Contact-Phone--desktop',
                            'Link',
                            'Link-primary',
                        ])}
                    >
                        {numberUtils.formatPhoneNumber(phone)}
                    </div>
                )}

                <div className="LeadRequest-Contact-Email">
                    <Anchor
                        href={`mailto:${email}`}
                        escape={true}
                    >
                        {email}
                    </Anchor>
                </div>
            </div>

            {isTwilioRecording ? (
                // eslint-disable-next-line jsx-a11y/media-has-caption
                <audio controls={true}>
                    <source src={message} />
                </audio>
            ) : (
                <Text className="LeadRequest-Message">
                    {message}
                </Text>
            )}

            {children}
        </div>
    );
}

LeadRequest.propTypes = propTypes;

export default LeadRequest;
